import { ObservableArray, View } from "binder"
import { InWayViewModel, item } from "./inWay-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel } from "uicomponents";

export class InWayView extends View<InWayViewModel>{
    GetViewUniqueId(): string {
        return "V-59DA66F5-90C7-4864-8A0A-081B7D472CF8"
    }
    loadHtml(): string {
        let element = require('./inWay.html').default;
        let style = require('./inWay.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
 
    exportExcel(){
        this.dataContext.exportExcel();
    }

    import(){
        this.dataContext.importExcel();
    }
}
